CardLabelSelectView = require 'app/scripts/views/label/card-label-select-view'
CardMemberSelectView = require 'app/scripts/views/card/card-member-select-view'
ComposerPosSelectorView = require 'app/scripts/views/card-composer/composer-pos-selector-view'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
templates = require 'app/scripts/views/internal/templates'
selectorMenuTemplate = require 'app/scripts/views/templates/popover_selector_menu'
{ featureFlagClient } = require '@trello/feature-flag-client'

module.exports = class ComposerSelectorMenuView extends View
  viewTitleKey: 'options'

  events:
    'click .js-mem-selector': 'openMemSelector'
    'click .js-label-selector': 'openLabelSelector'
    'click .js-pos-selector': 'openPosSelector'

  initialize: ->
    @templateFlagEnabled = featureFlagClient.get('publicproduct.templates_v1', false)
    featureFlagClient.on 'publicproduct.templates_v1', false, (newVal) =>
      @templateFlagEnabled = newVal

  render: ->
    view = @

    @$el.html selectorMenuTemplate({
      isTemplate: @templateFlagEnabled && @model.board.isTemplate()
    })

    @

  openMemSelector: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: CardMemberSelectView
      options: { @model, @modelCache }

  openLabelSelector: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: CardLabelSelectView
      options: { @model, @modelCache, hideOnSelect: false }

  openPosSelector: (e) ->
    Util.stop(e)
    PopOver.pushView
      view: ComposerPosSelectorView
      options: { @model, @modelCache }
